import { useQuery } from '@tanstack/react-query'
import api from '@/services/api'
import type { MapPole, PoleMapResponse } from '@/types/pole'

export interface UsePoleMapResult {
  mapPoles: MapPole[] | null
  isLoading: boolean
}

// 指定時刻時点のポールマップ（既知ポール位置）を取得
export function usePoleMap(
  forkId: string | undefined,
  timestamp?: string
): UsePoleMapResult {
  const { data, isLoading } = useQuery({
    queryKey: ['poleMap', forkId, timestamp],
    queryFn: async () => {
      const params: Record<string, string> = { fork_id: forkId! }
      if (timestamp) params.timestamp = timestamp
      const { data } = await api.get<PoleMapResponse>('/pole-map', { params })
      return data
    },
    enabled: !!forkId,
    staleTime: 1000 * 60 * 5, // ポールマップは頻繁に変わらないため5分
    gcTime: 1000 * 60 * 30,
  })

  return {
    mapPoles: data?.poles ?? null,
    isLoading,
  }
}
